import { DatePickerDesignTokens } from '@primeuix/themes/types/datepicker';

export const datePickerPreset: DatePickerDesignTokens = {
  colorScheme: {
    dark: {
      panel: {
        background: '{nspSlate.700}',
        color: '{nspSlate.0}',
      },
      inputIcon: {
        color: '{nspSlate.50}',
      },
      weekDay: {
        color: '{nspSlate.0}',
      },
      header: {
        background: '{nspSlate.700}',
        color: '{nspSlate.0}',
      },
      date: {
        color: '{nspSlate.0}',
        hoverBackground: '{nspSky.300}',
        rangeSelectedBackground: '{nspSky.500}',
        rangeSelectedColor: '{nspSlate.0}',
        selectedBackground: '{nspSky.500}',
        selectedColor: '{nspSlate.0}',
      },
      selectMonth: {
        color: '{nspSlate.0}',
        hoverBackground: '{nspSky.300}',
      },
      selectYear: {
        color: '{nspSlate.0}',
        hoverBackground: '{nspSky.300}',
      },
    },
    light: {
      panel: {
        background: '{nspSlate.700}',
        color: '{nspSlate.0}',
      },
      weekDay: {
        color: '{nspSlate.0}',
      },
      header: {
        background: '{nspSlate.700}',
        color: '{nspSlate.0}',
      },
      date: {
        color: '{nspSlate.0}',
        hoverBackground: '{nspSky.300}',
        rangeSelectedBackground: '{nspSky.500}',
        rangeSelectedColor: '{nspSlate.0}',
        selectedBackground: '{nspSky.500}',
        selectedColor: '{nspSlate.0}',
      },
      selectMonth: {
        color: '{nspSlate.0}',
        hoverBackground: '{nspSky.300}',
      },
      selectYear: {
        color: '{nspSlate.0}',
        hoverBackground: '{nspSky.300}',
      },
    },
  },
};
